module.exports = __webpack_public_path__ + "img/1.ae3f02d6.png";